import React from 'react';

import './styles.css';

function TextInput({
  label, placeholder = '', value, setValue, warningMessage = undefined, disabled = false, type = 'text', inputRef = null,
}) {
  return (
    <div className="text-input-component" ref={inputRef}>
      <p className="label">{label}</p>
      <input
        className={`input ${warningMessage ? 'invalid' : ''} ${!warningMessage && value && !disabled ? 'valid' : ''} ${disabled ? 'disabled' : ''}`}
        value={value}
        type={type}
        onChange={(e) => setValue(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
      />
      <p className="warning-message">{warningMessage}</p>
    </div>
  );
}

export default TextInput;